import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "../../../lib/utils/cn";

interface Props {
  onClick?: () => void;
}

export default function FloatingButton({ onClick }: Props) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  useEffect(() => {
    if (isExpanded) {
      const timer = setTimeout(() => {
        setIsExpanded(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isExpanded]);

  const handleButtonClick = () => {
    if (isExpanded) {
      if (onClick) {
        onClick();
      }
    } else {
      setIsExpanded(true);
    }
  };

  return (
    <motion.button
      layout
      onClick={handleButtonClick}
      className={cn(
        `rounded-full flex items-center justify-center gap-[10px] bg-[#e5002b] text-white font-bold`,
        isExpanded ? "h-14" : "size-14",
      )}
      style={{
        padding: isExpanded ? "16px 18px" : "18px",
      }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
    >
      <img className="size-6" src="/icons/ic-write.webp" alt="글쓰기 아이콘" />

      <AnimatePresence>
        {isExpanded && (
          <motion.span
            initial={{ opacity: 0, width: 0 }}
            animate={{ opacity: 1, width: "auto", marginLeft: "2px" }}
            exit={{ opacity: 0, width: 0, marginLeft: "0px" }}
            transition={{ duration: 0.2 }}
            className="text-lg font-[500] whitespace-nowrap"
          >
            글쓰기
          </motion.span>
        )}
      </AnimatePresence>
    </motion.button>
  );
}
